<template>
<div>
  <div class="container form-container">
      <div class="row pb-3">
          <div class="col-12 col-md-4">
              <div class="clinical-trials-content">
                  <h2 :class="post_title_h_style">{{ post_title }}</h2>
                  <div v-html="post_description"></div>
              </div>
          </div>
          <div class="col-12 col-md-8">
            <form id="event-search-form" class="vue-app">
                <div class="form-row">
                    <div class="col-12">
                        <h5>Filter Events By:</h5>
                        <div class="form-group">
                            <input id="keyword" type="text" class="form-control" placeholder="Keyword" v-model="form.keyword" ref="keyword">
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <startdate placeholder="Start Date" v-model="form.start_date" name="start_date" :clear-button="true" :typeable="true"></startdate>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <enddate placeholder="End Date" v-model="form.end_date" name="end_date" :clear-button="true" :typeable="true"></enddate>
                        </div>
                    </div>
                </div>
                <div class="form-row pt-2">
                    <button type="submit" @click.prevent="searchEvents(true)" class="btn btn-primary mx-1">Search</button>
                    <button type="submit" @click.prevent="resetForm()" class="btn btn-dark">Reset Form</button>
                </div>
            </form>
          </div>
      </div>
  </div>
  <div class="container-fluid clip-path-ellipse-concave-square" id="events-results-wrap">
    <div class="container py-3">
      <div class="row vue-search-results" id="events-results">
          <events-results v-for="event in events" :key="event['title']" :event="event"></events-results>
          <div class="col-12" v-bind:class="{'d-none': total_count || !initialized }">{{ no_results_message }}</div>
      </div>
    </div>
    <div class="container py-2" v-bind:class="{'d-none': has_more }">
      <div class="row justify-content-center">
        <button type="button" @click.prevent="showCards()" class="btn btn-primary">Load More Results</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import ApiCalls from "../../api/apiServices"
import EventResults from "../results/wf-events-results.vue"
import Helpers from "../../scripts/helpers"
import { mapMutations } from 'vuex'

export default {
    data() {
        return {
            post_title: window.event_search ? window.event_search.form_title : '',
            post_title_h_style: window.event_search && window.event_search.form_title_h_style ? window.event_search.form_title_h_style : "h4",
            post_description: window.event_search ? window.event_search.form_description : '',
            form: {},
            events: '',
            no_results_message: window.event_search ? window.event_search.no_results_message : 'No results found.',
            initialized: false
        }
    },
    computed: {
        has_more() {
            return this.$store.state.results_count <= this.$store.state.shown_count
        },
        eventResults() {
            return this.events
        },
        total_count() {
            return this.$store.state.results_count
        }
    },
    methods: {
        ...mapMutations(
            ['incrementCount', 'resetCount', 'showMore', 'showMoreEvents']
        ),
        searchEvents(scroll = false){
            this.resetCount(this)
            ApiCalls.getEvents(this.form.keyword, this.form.start_date, this.form.end_date).then((data) => {
                if(data != null) {
                    for (var post in data) {
                        this.incrementCount(this)
                    }
                    this.$set(this, 'events', data)
                    setTimeout( this.showCards, 400)
                }
                this.$set(this, 'initialized', true);
                if (scroll) {
                    document.querySelector('.vue-search-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            })
        },
        resetForm(){
            this.form = {
                keyword: null,
                start_date: null,
                end_date: null
            }
        },  
        resetEventCount(){
            this.resetCount(this)
        },
        showCards(){
            this.showMoreEvents(this)
            let cards = document.querySelectorAll('#events-results .card-wrap:not(.active)')
            let count = 0
            if(cards != null && cards.length > 0){
                [...cards].forEach((card) => {
                if(count < this.$store.state.events_shown_count) {
                    if(!card.classList.contains('active')) {
                    card.classList.add('active')
                    }
                    count++
                }
                })
            } else {
                setTimeout( this.showCards, 400)
            }
        },
        showMoreCards(){
            this.showMore(this)
            this.showCards()
        },
    },
    mounted() {
        this.resetEventCount()
    },
    created() {
        this.searchEvents()
    },
    components: {
        'startdate' : Datepicker,
        'enddate' : Datepicker,
        'events-results' : EventResults
    }
}
</script>